export const CHIPLO_INMOBILIARIA_ID = '65a1bf592f98833cd83c2187';
export const CIFRAS_INMOBILIARIA_ID = '66d75ed176ec12003655d455';
